<template>
    <l-map style="" ref="mainMap" :options="{ zoomControl: false }"
        :zoom="zoom" 
        :center="center">

        <!--Fix elemek-->        

        <l-control-zoom position="topright"></l-control-zoom>         

        <l-control-scale 
            :imperial="scale.imperial" 
            :maxWidth="scale.maxWidth" 
            position="bottomleft">
        </l-control-scale> 

        <l-control-layers position="bottomright"></l-control-layers>        
        
        <l-tile-layer ref="tileLayer" layerType="base"
            v-for="tileProvider in baseTileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :options="tileProvider.options"
            :attribution="tileProvider.attribution">
        </l-tile-layer>   

        <l-tile-layer layerType="overlay" 
            v-for="tileProvider in overlayTileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution">                        
        </l-tile-layer>

        <!--Változó elemek-->

        <l-feature-group v-if="markers" ref="fgroup" :visible="markersVisible" layerType="overlay" name="Pontok">
            <l-marker v-for="marker in markers"
                :key="marker.id"
                :visible="marker.visible"
                :lat-lng="marker.position"
                :title="marker.text"
                :icon="marker.icon">
                <l-popup style="z-index:5000;">                    
                    <div v-if="marker.allInfo">
                        <img :src="marker.allInfo.imgUrl" style="width:300px" class="w3-card-2">
                        <div class="w3-container w3-white">                 
                            <p class="route-title">{{marker.allInfo.name}}</p>
                            <div class="w3-right">{{marker.allInfo.price}} {{$appData.currency}}</div>
                            <p>{{marker.allInfo.distance}} km / {{marker.allInfo.level}} m</p>
                            <p class="w3-justify">{{marker.allInfo.description | filterTruncate(300)}}</p>
                            <div class="w3-center w3-margin">
                                <div v-on:click="$router.push('/routeinfo/'+marker.allInfo.id)" class="w3-button w3-border w3-border-green w3-green w3-hover-white" style="width:100px;">Részletek</div>                        
                            </div>
                        </div>
                    </div>
                    <div v-if="marker.allPointInfo">
                        <img v-if="marker.allPointInfo.imgUrl" :src="marker.allPointInfo.imgUrl" style="width:300px" class="w3-card-2">
                        <div class="w3-container w3-white">                 
                            <p class="route-title">{{marker.allPointInfo.name}}</p>
                            <p v-if="marker.allPointInfo.description" class="w3-justify">{{marker.allPointInfo.description | filterTruncate(300)}}</p>
                        </div>
                    </div>
                    
                </l-popup>
            </l-marker>      
        </l-feature-group>          
        
        <l-geo-json v-if="geoJsonTrack" layerType="overlay" name="Track"
            :geojson="geoJsonTrack"
            :options="trackStyle">
        </l-geo-json>  

        <l-circle v-if="point"
            :lat-lng="circleCenter"
            :radius="parseInt(point.radius)">
        </l-circle>      
        <l-marker v-if="point"
            :lat-lng="center"
            :title="point.name"
            :draggable="markerDragable"
            @drag="markerDragend" >
            <l-popup :content="point.name"></l-popup>
        </l-marker>

        <l-control position="topleft" v-if="source=='certify-point'" >            
            <div class="w3-white w3-padding w3-border ">                
                <div class="w3-bar-item w3-large w3-center">{{point.name}}</div>
                <div v-if="display.distS">
                    <div class="w3-center">
                        <span v-if="display.distM>point.radius" class="w3-text-red">{{display.distS}}</span>
                        <span v-else class="w3-text-green">{{display.distS}}</span>
                        <br><span class="w3-center">{{display.timestamp | filterDateTimeFormat}}</span>
                    </div>      
                    <div class="w3-center">
                        <div v-if="isCheckButton">
                            <div v-if="showCertifyButton" v-on:click="pointCertify" class="w3-button w3-border w3-border-green w3-green w3-hover-white">
                                <font-awesome-icon icon="stamp" ></font-awesome-icon>                    
                                Igazolás                    
                            </div>
                            <div v-else>
                                <font-awesome-icon size="2x" icon="spinner" spin></font-awesome-icon>   
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="w3-center w3-padding">
                    <font-awesome-icon size="4x" icon="spinner" spin></font-awesome-icon>
                </div>
            </div>                                                            
        </l-control> 
       
        <l-control position="topleft" v-if="source=='allRoute'" >   
              <div class="w3-button w3-border w3-border-green w3-green w3-hover-white" v-on:click="goBackAllRoute(0)">
                  Kártya nézet
              </div>
              <div class="w3-button w3-border w3-border-green w3-green w3-hover-white" v-on:click="goBackAllRoute(1)">
                  Lista nézet
              </div>

        </l-control> 

        <l-control position="topleft" v-if="source=='create-point'" >            
            <div class="w3-white w3-padding w3-border ">                
                <div class="w3-large w3-center w3-text-blue">{{point.name}}</div>
                <div class="w3-margin-top">
                    <label class="w3-text-blue">Lat</label>
                    <input v-model="point.lon" type="number" class="w3-input w3-border w3-light-grey" >
                </div>
                <div class="w3-margin-top">
                    <label class="w3-text-blue">Lon</label>
                    <input v-model="point.lat" type="number" class="w3-input w3-border w3-light-grey" >
                </div>
                <div class="w3-margin-top">
                    <label class="w3-text-blue">Sugár</label>
                    <input v-model="point.radius" type="number" class="w3-input w3-border w3-light-grey" >
                </div>
                <div class="w3-center w3-margin">
                    <div v-on:click="pointDataCopy" class="w3-button w3-blue">Adatok másolása</div>
                    <div v-on:click="pointDataCancel" class="w3-button w3-red w3-margin-left ">Mégsem</div>
                </div>
            </div>                                                            
        </l-control> 

        <l-control position="topleft" v-if="source=='checkGPS'" >    
            <div v-if="!GPSData" v-on:click="showGPS" class="w3-button w3-border w3-border-green w3-green w3-hover-white">Helyadatok megjelenítése</div>        
            <div  v-if="GPSData" class="w3-white w3-padding w3-border ">                         
                    <div class="">
                        <label class="w3-text-blue">Lat</label>
                        <div class="w3-input w3-border w3-light-grey" >{{GPSData.lon}}</div>
                    </div>
                    <div class="">
                        <label class="w3-text-blue">Lon</label>
                        <div class="w3-input w3-border w3-light-grey" >{{GPSData.lat}}</div>
                    </div>
                    <div class="">
                        <label class="w3-text-blue">Pontosság (m)</label>
                        <div class="w3-input w3-border w3-light-grey" >{{GPSData.accuracy}}</div>
                    </div>
                    <div class="">
                        <label class="w3-text-blue">Időbélyeg</label>
                        <div class="w3-input w3-border w3-light-grey" >{{GPSData.timestamp | filterDateTimeFormat}}</div>
                    </div>
                    <div class="w3-center w3-margin-top">
                        <div v-on:click="showGPS" class="w3-button w3-border w3-border-green w3-green w3-hover-white">Frissítés</div>                        
                        <div v-on:click="cancelGPS" class="w3-button w3-border w3-border-blue w3-blue w3-hover-white">Bezárás</div>
                    </div>
            </div>                                                            
        </l-control> 

    </l-map>
</template>

<script>
var greenIcon = new L.Icon({
  iconUrl: require('../assets/img/icon/marker-icon-green.png'),  
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var yellowIcon = new L.Icon({
  iconUrl: require('../assets/img/icon/marker-icon-yellow.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var greyIcon = new L.Icon({
  iconUrl: require('../assets/img/icon/marker-icon-grey.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var redIcon = new L.Icon({
  iconUrl: require('../assets/img/icon/marker-icon-red.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

var mapSettings = require('../assets/jsons/mapSettings.json')
import {LMap, LGeoJson, LTileLayer, LControlScale, LIcon, LMarker, LPolyline, LPopup, LTooltip, LControlLayers, LLayerGroup, LFeatureGroup, LControl, LControlZoom, LCircle} from 'vue2-leaflet';
const fb = require('../firebase.js');
import "../filters.js";
var locControl=null;
var savedPoint=null;
export default {
    name: 'MainMap',
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LPopup,
        LTooltip,
        LControl,
        LIcon,
        LControlZoom,
        LControlLayers,
        LLayerGroup,
        LFeatureGroup,
        LControlScale,
        LGeoJson,
        LCircle
    },    
    props: {
        source: {
            type: String,
            default: ""
        },
        point: {
            type: Object,
            default: function () {
                return null;
            }            
        },
        isCheckButton:{
            default: true
        }     
    },
    data() {
        return {
          zoom: 8,
          center: L.latLng(this.$appData.map.center.lat, this.$appData.map.center.lng),
          circleCenter: null,
          baseTileProviders: null,
          overlayTileProviders: null,
          scale: mapSettings.scale,
          trackStyle: mapSettings.trackStyle,
          markersVisible: true,
          markers: null,
          geoJsonTrack: null,
          distM:null,
          distS:null,
          display:{
              timestamp:0,
              distM:0,
              distS:""
          },
          GPSData:null,
          certifyMessage:'Sikeres pontérintés!',
          markerDragable:false,
          showCertifyButton:true,
        }
    },
    timers: {
      setCertifyData: { time: 3000, autostart: false, repeat: true }
    },        
    methods:{
        goBackAllRoute(n) {
            if (n==0) this.$storage.set('routeView', [true,false,false]);
            if (n==1) this.$storage.set('routeView', [false,true,false]);
            this.$router.push('/routes');
        },
        cancelGPS(){
            this.GPSData=null;
        },
        showGPS(){
            var loc=this.$storage.get('location', null);
            if (loc) {
               var data= {
                    timestamp:loc.time,
                    lon:loc.lat,
                    lat:loc.lan,
                    accuracy:loc.accuracy,
                    time:loc.time
                };
                this.GPSData=data;
                this.center=L.latLng(loc.lat, loc.lan);
                this.zoom=14;
            } else {
                this.GPSData.warning="Hiba";
            }
        },
      pointDataCancel(){
        this.$storage.set('actualCreatedPoint', savedPoint);          
        this.$router.push('createhike');
      },        
      pointDataCopy(){
        this.$storage.set('actualCreatedPoint', this.point);
        this.$router.push('createhike');
      },
      markerDragend(loc){
          this.circleCenter=loc.latlng;
          this.point.lon=loc.latlng.lat;
          this.point.lat=loc.latlng.lng;
      },
      pointCertify(){
          try{
            this.showCertifyButton=false;
            var appSettings = this.$storage.get('appSettings', null);
            //if ((this.display.distM<=this.point.radius) || (appSettings.testSettings.anyDistance==='true')) {
            if ((1!=1) || (this.display.distM<=this.point.radius)) {                
                var cert=this.$storage.get('actualCertify', null); 
                if (cert.status==0) {
                    cert.startdate=this.point.timestamp;
                    cert.status=1;
                }
                cert.enddate=this.point.timestamp;                
                cert.sumtime=parseInt(cert.enddate/1000-cert.startdate/1000,10);
                cert.points[this.point.id]=this.point.timestamp;                  
                var favoriteList = this.$storage.get('favoriteList', null);
                favoriteList[cert.id]=cert;
                this.$storage.set('favoriteList', favoriteList);                 
                this.$storage.set('actualCertify', cert);
                if (this.isOnline) {
                    fb.UpdateCertify(cert).then(res=>{ 
                    }).catch(e=>{
                        var uploadCertifyList = this.$storage.get('uploadCertifyList', []);              
                        if (!uploadCertifyList.includes(cert.id)) uploadCertifyList.push(cert.id);
                        this.$storage.set('uploadCertifyList', uploadCertifyList);  
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok feltöltése során.'));
                        this.showCertifyButton=true;
                        console.log(e);
                    })
                } else {
                    var uploadCertifyList = this.$storage.get('uploadCertifyList', []);              
                    if (!uploadCertifyList.includes(cert.id)) uploadCertifyList.push(cert.id);
                    this.$storage.set('uploadCertifyList', uploadCertifyList);                                                             
                }
                
                let self=this; 
                this.$dialog.alert(this.$setDialogMsg('w3-green',this.point.name,this.certifyMessage))
                .then(function(dialog) {
                    self.$router.push('certify');
                });
            } else {
                this.showCertifyButton=true;
                this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Még messze vagy a ponttól!<br>Legalább '+this.point.radius+' méterre meg kell közelítened a pontot a sikeres pontérintéshez.'));  
            }
          }catch(e){
            console.log(e);              
            this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok mentése során. A hiba elhárítása érdekében próbáld meg a következőt: Indítsd újra a csavargo.eu oldalt, majd válaszd ki újra a Teljesítéseim listából a túra teljesítését.'));
            this.showCertifyButton=true;
          }
      },
      setCertifyData(){
            var loc=this.$storage.get('location', null);
            if (loc) {
                var d=this.$distance(loc.lat,loc.lan,this.point.lon,this.point.lat);                      
                this.zoom=Math.round(14-Math.log(d)/Math.LN2);
                if (d>10) this.point.distS=Math.round(d) +" km";
                else this.point.distS=Math.round(d*1000) +" m";
                this.point.distM=Math.round(d*1000);
                this.point.timestamp=loc.time;
                this.display.timestamp=this.point.timestamp;
                this.display.distM= this.point.distM;
                this.display.distS=this.point.distS; 
            }
      },
      mapSettings(){
        const appSetting=this.$storage.get('appSettings', false);
        if (appSetting) {
            const tpName=appSetting.map.tileProvider;
            for (var i in mapSettings.baseTileProviders) {
                mapSettings.baseTileProviders[i].visible=(mapSettings.baseTileProviders[i].name==tpName);
            }
            this.baseTileProviders=mapSettings.baseTileProviders;
            mapSettings.overlayTileProviders[0].visible=appSetting.map.layers.turistautak;
            mapSettings.overlayTileProviders[1].visible=appSetting.map.layers.szintvonalak; 
            this.overlayTileProviders=mapSettings.overlayTileProviders;
        }
      },
      addControls(){
        const map = this.$refs.mainMap.mapObject;
        locControl=new window.L.control.locate({ "position": "topright" });
        map.addControl(locControl);
        if ((this.source=='certify-point') || (this.source=='checkGPS')) locControl.locate(); //pozíció figyelés elindítása
        map.addControl(new window.L.Control.Fullscreen({ "position": "topright" }));
        if (this.markers) {
            const fgroup = this.$refs.fgroup.mapObject;
            map.fitBounds(fgroup.getBounds());//Ez állítja be a térkép pozíciót a pontok alapján 
        } 
      },
      
    },
    created(){
        try{
            this.mapSettings();
            var loc=this.$storage.get('location', false);
            if (loc) {
                this.center= L.latLng(loc.lat, loc.lan);
            }
            if ((this.source=='certify-point') || (this.source=='create-point')){
                this.center=L.latLng(this.point.lon, this.point.lat);
                this.zoom=12;
                this.point.radius=parseInt(this.point.radius);
            }
            if ((this.source=='certify-point')){
                var cert=this.$storage.get('actualCertify', null);
                this.point.certifyId=cert.id;
                if (this.point.message) this.certifyMessage=this.point.message;   
                this.geoJsonTrack = this.$storage.get('actualTrack', null);
            }
            if (this.source=='create-point') {
                this.markerDragable=true;
                this.zoom=16;
                savedPoint = Object.assign({}, this.point);
            }     
            if (this.source=='allRoute'){                
                this.markers=this.$route.params.markers;
            }
            if (this.source=='oneRoute'){                
                this.markers=this.$route.params.markers;
                this.geoJsonTrack = this.$storage.get('actualTrack', null);
            }            
            this.circleCenter=this.center;  
        }catch(e){
            console.log(e);
        }   
    },
    mounted() {
      this.$nextTick(() => {
          try {
            this.addControls();        
            if (this.source=='certify-point') this.$timer.start('setCertifyData');        
          }catch(e){
                console.log(e);              
          }  
      });
    },   
    destroyed(){
        if (locControl) locControl.stopLocate();
    }           
}
</script>

